import HistorySvg from './HistorySvg';

export default HistorySvg;
